import { createApp } from 'vue'


import App from './App.vue'
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

// import { vMaska } from "maska"
import i18n from "./i18n"
// import { initFirebaseBackend } from './authUtils'
// import { configureFakeBackend } from './helpers/fake-backend';

import BootstrapVueNext from 'bootstrap-vue-next'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import "@/assets/scss/app.scss";
import "@vueform/multiselect/themes/default.css"

import Vueform from '@vueform/vueform'                   //Vueform
import vueformConfig from '../vueform.config'          //Vueform

// PINIA
import pinia, { useAuthStore, useSettingsStore } from '@/state/pinia'






// const firebaseConfig = {
//   apiKey: process.env.VUE_APP_APIKEY,
//   authDomain: process.env.VUE_APP_AUTHDOMAIN,
//   databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//   projectId: process.env.VUE_APP_PROJECTId,
//   storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
//   appId: process.env.VUE_APP_APPId,
//   measurementId: process.env.VUE_APP_MEASUREMENTID
// };

// if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
//   initFirebaseBackend(firebaseConfig);
// } else {
//   configureFakeBackend();
// }

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';

import { initAxiosBackend } from './helpers/axios';
const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL,
  baseURLMubinApi: process.env.VUE_APP_MUBIN_API_URL,
};
initAxiosBackend(axiosConfig)

import { initGlobalErrorHandler } from './helpers/requestErrorHandler';
import { useErrorStore } from '@/state/pinia/errorStore';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { directives } from './helpers/directives';



const app = createApp(App)
  .use(Vueform, vueformConfig)   //Vueform
  .use(pinia)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVueNext)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  // .directive("maska", vMaska)
  // .mount('#app')

// Register custom directives
// directives.forEach(directive => {
//   app.directive(directive.name, directive.func);
// });

directives.forEach(directive => {
  app.directive(directive.name, {
    mounted: directive.func,
    updated: directive.func,
  });
});

pinia.use(piniaPluginPersistedstate)

// بدء تحديث جداول اللوكاب عند تشغيل التطبيق وبعد تسجيل الدخول
const authStore = useAuthStore();
const settingsStore = useSettingsStore();
const lookupRefreshInterval = process.env.VUE_APP_LOOKUP_REFRESH_INTERVAL || 900000; // 15 دقيقة

if (authStore.loggedIn) {
  settingsStore.startLookupRefresh(lookupRefreshInterval);
}

authStore.$subscribe((_mutation, state) => {
  if (state.token) {
    settingsStore.startLookupRefresh(lookupRefreshInterval);
  } else {
    settingsStore.stopLookupRefresh();
  }
});

// Initialize global error handler for frontend errors
initGlobalErrorHandler();

// Add Vue error handler
app.config.errorHandler = (error, instance, info) => {
  console.groupCollapsed("[Vue Error]");
  console.error("Vue error:", error);
  console.error("Instance:", instance);
  console.error("Info:", info);
  console.groupEnd();
  
  // Show error message to user
  const errorStore = useErrorStore();
  const frontendErrorMessage = "حدث خطأ غير متوقع. يرجى تحديث الصفحة والمحاولة مرة أخرى";
  
  // Check if error already exists
  const errorExists = errorStore.errors.some(storedError => 
    storedError === frontendErrorMessage
  );
  
  if (!errorExists) {
    errorStore.pushMessages([frontendErrorMessage]);
  }
};

app.mount('#app')

  // export function myPiniaPlugin({ store, options }) {
  //   const shouldPersist = options.persist !== false; // افتراضيًا true
  
  //   if (shouldPersist) {
  //     const storedState = localStorage.getItem(store.$id)
  //     if (storedState) {
  //       store.$patch(JSON.parse(storedState))
  //     }
  
  //     store.$subscribe((_, state) => {
  //       localStorage.setItem(store.$id, JSON.stringify(state))
  //     })
  //   }
  // }
  

  // pinia.use(myPiniaPlugin)


  // import { useAuthStore } from "@/state/pinia";
  // const useAuth = useAuthStore()



  // Array.prototype.mapList = function() {
  //   return this.map(x => {
  //     return { value: x.id, label: x.name };
  //   });
  // };